/**
 * Inline dietary tag chips — THE shared inline-row treatment for dietary
 * claims on menu-item listings (family day rows, the school order grid).
 * Wraps `@ordo/ui/tag-chip`'s `DietaryTagChip` with the compact inline
 * sizing so "Vegetarian" reads identically next to an item name on every
 * ordering surface. Renders nothing when there are no tags, so callers
 * never emit an empty container.
 */

import { DietaryTagChip } from '@ordo/ui/tag-chip'
import type { ReactElement } from 'react'

/** Compact chip sizing for inline rows (matches the family day-row chips). */
export const INLINE_DIETARY_TAG_CHIP_CLASS = 'px-1.5 py-0 text-[11px] font-medium leading-4'

export interface DietaryTagChipsProps {
  /** Display labels to render, already filtered/ordered by the caller. */
  tags: readonly string[]
}

/**
 * The chips only — no layout wrapper, so callers drop them into their own
 * flex-wrap row alongside prices/badges. Returns null for an empty list.
 */
export function DietaryTagChips({ tags }: DietaryTagChipsProps): ReactElement | null {
  if (tags.length === 0) {
    return null
  }
  return (
    <>
      {tags.map((tag) => (
        <DietaryTagChip key={tag} label={tag} className={INLINE_DIETARY_TAG_CHIP_CLASS} />
      ))}
    </>
  )
}
